import { Box, Skeleton, Stack } from '@mui/material';
import React from 'react';

interface ITabsLoader {
  titleWidth?: number;
  rowCount?: number;
}

const TabLoader: React.FC<ITabsLoader> = ({ titleWidth = 250, rowCount = 15 }) => {
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Skeleton animation="wave" height={30} width={titleWidth} />
      {Array(rowCount)
        .fill(0)
        .map(() => (
          <Stack direction="row" display="flex" justifyContent="space-between">
            <Skeleton animation="wave" height={30} width={100} />
            <Skeleton animation="wave" height={30} width={150} />
          </Stack>
        ))}
    </Box>
  );
};

export default TabLoader;
